import React from "react";

const Loader = () => {
    return (
        <div class="load-bar">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div>
    );
};

export default Loader;